const LISTE_ECHEANCES_A_PAYER_FACTURE = {
  title: 'Liste des échéances à payer',
  nonPaye: 'Non payé',
  paye: 'Payé',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des échéances à payer',
  },
  displayEchAnt: 'Afficher les échéances antérieures non payées ({total})',
  masquerEchAnt: 'Masquer les échéances antérieures non payées',
  actions: {
    filtre: 'Filtre',
    search: 'Rechercher',
    creerRemiseBancaire: 'Créer remise(s) bancaire(s)',
  },
  tab: {
    factureCode: 'Facture',
    dateFacture: 'Date de la facture',
    payeur: 'Payeur',
    compteComptable: 'Compte comptable',
    dateMouvement: 'Date de l\'écheance',
    montantTtc: 'Montant TTC',
    resteALettrer: 'Reste à payer',
    modeReglementLibelle: 'Mode de règlement',
    commercial: 'Commercial',
    assistant: 'Assistante',
    etat: 'Etat',
    banque: 'Banque',
    iban: 'IBAN',
    rum: 'RUM',
    dateSignatureMandat: 'Date mandat',
    agence: 'Agence',
    bic: 'BIC',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    agence: 'Agence(s)',
    modeReglement: 'Mode de règlement',
    payeur: 'Payeur',
    codeFacture: 'Code facture',
    commercial: 'Commercial',
    natures: 'Natures',
    etat: 'Etat',
    assistant: 'Assistante',
    noAssistant: 'Sans assistant',
    noCommercial: 'Sans commercial',
    errors: {
      dateDebutGreaterDateFin: 'La date de début est plus grande que la date de fin.',
    },
  },
  popUpCreationRemiseBancaire: {
    title: 'Créer les remises bancaires',
    nom: 'Nom',
    nomAutomatique: 'Nom automatique',
    dateRemise: 'Date de la remise',
    modeReglement: 'Mode de règlement',
    nombreReglement: 'Nombre règlements',
    montantRemise: 'Montant remise TTC',
    montantResteAPayer: 'Reste à payer',
    banque: 'Banque',
    actions: {
      redirection: 'Rediriger vers les remises bancaires après création',
      cancel: 'Annuler',
      create: 'Créer',
    },
    success: {
      creationRemiseBancaire: 'La remise bancaire a été créé avec succès',
    },
    errors: {
      alreadyPayed: 'L\'échéance paiement est dèjà reglée',
    },
  },
  popUpReplanification: {
    title: 'Modifier la date d\'échéance',
    date: 'Nouvelle date d\'échéance',
    commentaire: 'Commentaire',
    messages: {
      errors: {
        datePlanification: 'date d\'échéance',
      },
    },
  },
};
export default LISTE_ECHEANCES_A_PAYER_FACTURE;
